import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, ExternalLink, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { OctopusMascot } from "@/components/Mascot";
import AdminProducts from "./AdminProducts";
import AdminCategories from "./AdminCategories";
import AdminContent from "./AdminContent";

const TABS = [
  { key: "products", label: "Produtos" },
  { key: "categories", label: "Categorias" },
  { key: "content", label: "Textos & Seções" },
];

export default function AdminPanel() {
  const [auth, setAuth] = useState(null); // null = checando, false = negado, obj = ok
  const [tab, setTab] = useState("products");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/auth/me")
      .then(({ data }) => setAuth(data))
      .catch(() => {
        setAuth(false);
        navigate("/admin/login");
      });
  }, [navigate]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("art3d_token");
    navigate("/admin/login");
  };

  if (!auth) {
    return (
      <div className="min-h-screen bg-soft-gradient flex items-center justify-center">
        <Loader2 className="animate-spin text-pink-500" size={32} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50" data-testid="admin-panel">
      <header className="sticky top-0 z-20 bg-white/85 backdrop-blur-md border-b border-slate-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <OctopusMascot size={34} />
            <span className="font-black text-slate-900">Painel <span className="text-gradient">Art3D</span></span>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/" data-testid="admin-view-store" className="text-xs font-bold text-slate-500 hover:text-pink-600 inline-flex items-center gap-1.5 px-3 py-2 rounded-full hover:bg-pink-50 transition-colors">
              <ExternalLink size={14} /> Ver loja
            </Link>
            <button onClick={logout} data-testid="admin-logout-btn" className="text-xs font-bold text-slate-500 hover:text-red-500 inline-flex items-center gap-1.5 px-3 py-2 rounded-full hover:bg-red-50 transition-colors">
              <LogOut size={14} /> Sair
            </button>
          </div>
        </div>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex gap-1 pb-2 overflow-x-auto">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              data-testid={`admin-tab-${t.key}`}
              className={`text-sm font-bold px-4 py-2 rounded-full whitespace-nowrap transition-colors ${
                tab === t.key ? "bg-brand-gradient text-white shadow-soft" : "text-slate-500 hover:bg-pink-50 hover:text-pink-600"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        {tab === "products" && <AdminProducts />}
        {tab === "categories" && <AdminCategories />}
        {tab === "content" && <AdminContent />}
      </main>
    </div>
  );
}
